<template>
    <main id="mainCtrl">
        <v-table id="notificationsTable" request-uri="notifications/getList" pagesize="50" ref="table" :show-eye="false">
            <template v-slot:header>
                <v-tr>
                    <v-th name="read_at" sort="read_at">Прочитан</v-th>
                    <v-th name="title" sort="title">Заголовок</v-th>
                    <v-th name="text" sort="text">Текст</v-th>
                </v-tr>
                <v-tr>
                    <v-th name="read_at" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                      {value: '', text: '\u00a0'},
                                      {value: '1', text: 'Да'},
                                      {value: '0', text: 'Нет'},
                                  ]"/>
                    </v-th>
                    <v-th name="title" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="text" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="notificationRow">
                    <v-td colspan="4">
                        <Notification :notification="item" @onRead="markAsRead(index)"/>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import Notification from "./NotificationItem";

export default {
    components: {
        Notification
    },
    methods: {
        markAsRead(index) {
            this.$bus.fire('updateMenu');
            this.$refs.table.rows[index - 1].read_at = this.$moment().format('YYYY-MM-DD HH:mm:ss');
        },
        markOpenNotification(notification) {
            const index = this.$refs.table.rows.findIndex(item => item.id === notification.id);
            this.$refs.table.rows[index].read_at = this.$moment().format('YYYY-MM-DD HH:mm:ss');
        },
    },
    created() {
        this.$bus.listen('markOpenNotification', (notification) => {
            this.markOpenNotification(notification)
        })
    },
}
</script>

<style>
#notificationsTable .tbody-container .table-cell {
    padding: 0 5px;
    cursor: default;
}
</style>
